import type { FormDataType } from 'integrations/types';

import type { MimecastGenericInputCreateRequest, MimecastInputCreateRequest } from './types';

export const toMimecastInputCreateRequest = ({
  mimecastName,
  clientId,
  clientSecret,
  contentTypes,
  mimecastThrottleEnabled,
  mimecastStoreFullMessage,
  pollingInterval,
}: FormDataType): MimecastInputCreateRequest => ({
  name: mimecastName?.value,
  client_id: clientId?.value,
  client_secret: clientSecret?.value,
  content_type: contentTypes?.value?.split(','),
  enable_throttling: !!mimecastThrottleEnabled?.value,
  store_full_message: !!mimecastStoreFullMessage?.value,
  polling_interval: pollingInterval?.value,
  polling_time_unit: 'MINUTES',
});

export const toGenericInputCreateRequest = ({
  mimecastName,
  clientId,
  clientSecret,
  mimecastThrottleEnabled,
  mimecastStoreFullMessage,
  pollingInterval,
  contentTypes,
}: FormDataType): MimecastGenericInputCreateRequest => ({
  type: 'org.graylog.enterprise.integrations.mimecastv2.MimecastV2Input',
  title: mimecastName.value,
  global: false,
  configuration: {
    client_id: clientId?.value,
    client_secret: clientSecret?.value,
    content_type: contentTypes.value.split(','),
    throttling_allowed: !!mimecastThrottleEnabled?.value,
    store_full_message: !!mimecastStoreFullMessage?.value,
    polling_interval: pollingInterval.value,
    polling_time_unit: 'MINUTES',
  },
});
